import React, {useState, useEffect} from 'react';
import { NavLink, useParams, useNavigate } from 'react-router-dom';
import { ExtinctionData } from './feactures/dataProvider';
import './styles/Uxhelper.css';

export const UXHelper = ({url, title, video}) => {

    const navigate = useNavigate();

    const PushUrl = (url) => {
        navigate(url);
    }

  return (
        <div className='UXH_container' onClick={() => PushUrl(url)}>
            <div className='visual_item_container'>
                <video src={video} typeof='video/webm' autoPlay muted loop className='video_item_menu'/>
                <span className='difuser_visual_menu_item'></span>
            </div>
            <div className='menu_item_title'>
                <h2>{title}</h2>
            </div>
        </div>
  )
}
export const DamageBar = ({ damage, height, templateid }) => {

    const [width, setwidth] = useState(0);
    const [damageIndicator, setDamageIndicator] = useState('');

    useEffect(() => {
        if(Number(templateid) === Number(ExtinctionData.ID_DUMMY_SUIT) || Number(templateid) === Number(ExtinctionData.ID_DUMMY_WEAPON)){
            calcDamageSpecial(damage)
        }else{
            calcDamage(damage);
        }
    
      return () => {
        //
      }
    }, [damage])
    

    const calcDamage = (damage) => {
        if(Number(damage) === 0){
            setwidth('100');
            setDamageIndicator('100/100');
        }
        else if(Number(damage) >= 1 && Number(damage) <= 29){
            let x = Math.round(100 - (damage * 3.33));
            setwidth(`${x}`);
            setDamageIndicator(`${x}/100`);
        }
        else if(Number(damage) === 30){
            setwidth('0');
            setDamageIndicator('DAMAGED');
        }
    }

    const calcDamageSpecial = (damage) => {
        if(Number(damage) === 0){
            setwidth('100');
            setDamageIndicator('100/100');
        }
        else if(Number(damage) === 1){
            setwidth('80');
            setDamageIndicator('75/100');
        }
        else if(Number(damage) === 2){
            setwidth('60');
            setDamageIndicator('50/100');
        }
        else if(Number(damage) === 3){
            setwidth('40');
            setDamageIndicator('25/100');
        }
        else if(Number(damage) === 4){
            setwidth('0');
            setDamageIndicator('DAMAGED');
        }
    }

    return(
        <div className='damage-box' style={{height: height}}>
            <p>{damageIndicator}</p>
            <span style={ {width: `${width}%`, height: '100%'}}></span>
        </div>
    )
}

export const ProgressBar = ({ width, height, colorUp, colorDown}) => {
    return(
        <div className='damage-box' style={{height: height, backgroundColor: colorDown}}>
            <span style={ {width: `${width}%`, height: '100%', backgroundColor: colorUp}}></span>
        </div>
    )
}

export const ItemEmpty = () => {

    return (
        <div>
            <div className='visual_item_container'>
                <video src={'https://extinctionwars.com/assets/videos/visuals/menu-items/no_item.webm'} typeof='video/webm' autoPlay muted loop className='img_item' alt={'Test'}/>
            </div>
            <div className='item-info-box2'>
                <DamageBar width={'0'} height={'15px'}/>
            </div>
        </div>
    )
}

export const OnConstruction = () => {
    
    return (
        <div className='signIn_box'>
            <h2 className='signIn-letter'>Section under construction!</h2>
        </div>
    )
}

export const VideoLoader = ({url, url2, autoClose}) => {

  const [screenWidth, setScreenWidth] = useState(window.innerWidth);


    useEffect(() => {
        const changeWidth = () =>{
          setScreenWidth(window.innerWidth);
        }
        window.addEventListener('resize', changeWidth);
        return () => {
          window.addEventListener('resize', changeWidth);
         
        }
    }, [])

    if(screenWidth < 750){
        return(
            <>
                <button className='close_videos_animations' onClick={autoClose}></button>
                <video src={`${url2}`} onPause={autoClose} autoPlay muted/>
            </>
        )
    }
    

    return (
        <>
            <button className='close_videos_animations' onClick={autoClose}></button>
            <video src={`${url}`} onPause={autoClose} autoPlay muted/>
        </>
    )
}

export const VideoPlayer = (props) => {

    const [screenWidth, setScreenWidth] = useState(window.innerWidth);
  
  
      useEffect(() => {
          const changeWidth = () =>{
            setScreenWidth(window.innerWidth);
          }
          window.addEventListener('resize', changeWidth);
          return () => {
            window.addEventListener('resize', changeWidth);
           
          }
      }, [])
  
      if(screenWidth < 750){
          return(
              <>
                  <video src={`${props.url2}`} className='video_container' loop autoPlay muted/>
              </>
          )
      }
      
  
      return (
          <>
              <video src={`${props.url}`} className='video_container' loop autoPlay muted/>
          </>
      )
  }

export const Paginator = ({pageAct, setPageAct}) => {
    return(
        <div className="page-container">
            {pageAct > 1 &&
            <button onClick={() => setPageAct(pageAct - 1)} className='btn-page'>Prev Page</button>            
            }
            <span className='page-ident'>{pageAct}</span>
            <button onClick={() => setPageAct(pageAct + 1)} className='btn-page'>Next Page</button>
        </div>
    )
}

export const FilterMaker = ({filters, clearFilters, capturerOne, capturerTwo}) => {
    return(
        <div className='filters_sections'>
                  <select value={filters.parts} onChange={capturerOne} className='filters-items-dual'>
                    <option defaultValue='Select Type'>Select Type</option>
                    <option value="Magazine">Magazine</option>
                    <option value="Barrel">Barrel</option>
                    <option value="Legs">Legs</option>
                    <option value="Helmet">Helmet</option>
                    <option value="Stock">Stock</option>
                    <option value="Arms">Arms</option>
                    <option value="BodyGun">BodyGun</option>
                    <option value="Chest">Chest</option>
                  </select>
                  {/* <select value={filters.nation} onChange={capturerTwo} className='filters-items'>
                    <option defaultValue='Select Nation'>Select Nation</option>
                    <option value="Silkhs">Silkhs</option>
                    <option value="Arakneths">Arakneths</option>
                  </select> */}
                  {(filters.isNation || filters.isParts)
                    ? <button onClick={() => clearFilters()} className='clear-filters'>Clear</button>
                    : <></>
                  }
                </div>
    )
}